<template>
  <main class="grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8">
    <div class="text-center">
      <Chip
        :rounded="false"
        severity="danger"
        dot
        outlined
      >
        403
      </Chip>
      <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">{{ $t('ui.errors.noAccess') }}</h1>
      <p class="mt-6 text-base leading-7 text-gray-600">{{ $t('ui.errors.noAccessDescription') }}</p>
      <div class="mt-10 flex items-center justify-center gap-x-6">
        <Button
          :label="$t('ui.errors.back')"
          severity="secondary"
          outlined
          icon="arrow-left"
          @click="retry"
        />
        <Button
          v-if="authStore.isLoggedIn"
          :label="$t('ui.common.signOut')"
          severity="primary"
          outlined
          @click="signOut"
        />
        <a
          href="mailto:support@retain.group"
          class="text-sm font-semibold text-gray-900"
        >
          <Button
            plain
            :label="$t('ui.errors.contactSupport')"
            severity="secondary"
          />
        </a>
      </div>
    </div>
  </main>
</template>

<script setup>
import { useRouter } from 'vue-router'
// stores
import { useAuthStore } from '@/stores/AuthStore.ts'
import { useSocketStore } from '@/stores/SocketStore.ts'

import Button from '@/components/button/Button.vue'
import Chip from '@/components/chip/Chip.vue'
import updateAbility from '@/config/update-ability.js'

const router = useRouter()

const authStore = useAuthStore()
const socketStore = useSocketStore()

// The socket is only initialised after a successful login into the app shell,
// so it may still be null when this page is reached straight from login
socketStore.socket?.emit('user-logged-out')

async function retry() {
  const response = await authStore.verify()
  if (response.success) {
    updateAbility(router)
    router.go(-1)
  } else {
    authStore.signOut()
  }
}

async function signOut() {
  authStore.signOut()
}
</script>
